import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import var1 from './assets/images/var1.png';


const JavaScriptLesson6 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3><strong>Variables</strong></h3>
    <p>Variables are named containers for storing data. This data is then referenced and manipulated by the program.</p>
    <p>A good example of this is a login system of an application. First, you enter your username on the interface. What you entered is stored in a <span className="text-primary">container</span> or <span className="text-primary">named location</span>.
      It is then compared to existing records on the database. This container that holds our data while that comparison is going on is called <strong>variable.</strong></p>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>Declaring a variable</strong></h4>
    <p>There are three (3) ways in which we can declare a variable in Javascript:</p>
    <ol>
      <strong><li>var</li></strong>
      <strong><li>let</li></strong>
      <strong><li>const</li></strong>
      </ol>
      <p>Each of these is used in some specific conditions in JavaScript.</p>
      </div>
      <div className="alert alert-secondary" role="alert">
      <h4><strong>Differences between var, let & const</strong></h4>
              <table class="table table-responsive table-bordered">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">var</th>
                  <th scope="col">let</th>
                  <th scope="col">const</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Can be re-declared</td>
                  <td>Cannot be re-declared</td>
                  <td>Cannot be re-declared</td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Can be re-assigned</td>
                  <td>Can be re-assigned</td>
                  <td>Cannot be re-assigned</td>
                </tr>
              </tbody>
            </table>
        </div>

      <div style={{ height: 450 }} />

   </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson6
